export default __webpack_public_path__ + "static/siemens-8380a3e51df1c9e56be87160f8602b1d.svg";